module.exports = __webpack_public_path__ + "177ee65e1511c858e5dd7387961e6ccc.svg";